export function headerTriggerConfig({ compact, typography }) {
    return {
        textTransform: "none",
        ...(compact
            ? {
                fontSize: typography.fontSize.smallFontSize,
                graphicFontSize: typography.fontSize.lgFontSize,
                metaFontSize: typography.fontSize.lgFontSize
            }
            : {})
    };
}
